// vuex
import { VuexModule, Module, Action, Mutation } from 'vuex-module-decorators'

@Module({ namespaced: true })
class LayoutStore extends VuexModule {
    public layoutType = 'horizontal'
    public layoutWidth = 'fluid'
    public leftSidebarType = 'dark'
    public topbar = 'dark'
    public loader = true

    @Mutation
    public CHANGE_LAYOUT (layoutType: string) {
      this.layoutType = layoutType
    }

    public CHANGE_LAYOUT_WIDTH (layoutWidth: string) {
      this.layoutWidth = layoutWidth
    }

    public CHANGE_LEFT_SIDEBAR_TYPE (leftSidebarType: string) {
			this.leftSidebarType = leftSidebarType
    }

    public CHANGE_TOPBAR (topbar: string) {
			this.topbar = topbar
    }

    public LOADER (loader: boolean) {
			this.loader = loader
    }

	@Action
	public changeLayoutType (layoutType: string) {
		this.context.commit('CHANGE_LAYOUT', layoutType)
	}

	public changeLayoutWidth (layoutWidth: string) {
		this.context.commit('CHANGE_LAYOUT_WIDTH', layoutWidth)
	}

	public changeLeftSidebarType (leftSidebarType: string) {
		this.context.commit('CHANGE_LEFT_SIDEBAR_TYPE', leftSidebarType)
	}

	public changeTopbar (topbar: string) {
		this.context.commit('CHANGE_TOPBAR', topbar)
	}

	public changeLoaderValue (loader: string) {
		this.context.commit('LOADER', loader)
	}
}

export default LayoutStore
